import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getWebsiteSettingData } from "../../Redux/action/MasterAction";

const FloatingSocial = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getWebsiteSettingData());
    }, [dispatch]);

    const { WebsiteSettingDataListApiData } = useSelector(
        (state) => state?.MasterReducer
    );

    return (
        <div className="floating-social">
            {WebsiteSettingDataListApiData?.instagram_link && (
                <a
                    href={WebsiteSettingDataListApiData.instagram_link}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <i className="fa-brands fa-square-instagram"></i>
                </a>
            )}

            {WebsiteSettingDataListApiData?.facebook_link && (
                <a
                    href={WebsiteSettingDataListApiData.facebook_link}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <i className="fa-brands fa-facebook"></i>
                </a>
            )}

            {WebsiteSettingDataListApiData?.linkedin_link && (
                <a
                    href={WebsiteSettingDataListApiData.linkedin_link}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <i className="fa-brands fa-linkedin"></i>
                </a>
            )}

            {WebsiteSettingDataListApiData?.twitter_link && (
                <a
                    href={WebsiteSettingDataListApiData.twitter_link}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <i className="fa-brands fa-square-x-twitter"></i>
                </a>
            )}
        </div>
    );
};

export default FloatingSocial;